import * as Sentry from '@sentry/react';
import { useEffect, type ReactNode } from 'react';
import { useAuthState } from '@packages/auth';
import { AuthContext } from './useAuth';

export function AuthProvider({ children }: { children: ReactNode }) {
  const state = useAuthState();

  useEffect(() => {
    if (state.user) {
      Sentry.setUser({ id: state.user.id });
    } else {
      Sentry.setUser(null);
    }
  }, [state.user]);

  return (
    <AuthContext value={state}>
      {children}
    </AuthContext>
  );
}
